import React, { FC } from 'react';
import styles from '../journey-explorer.module.scss';
import { InteractionInfo, resolveInfo } from '../journey-map-layout';
import { Dot } from './filter-group';

interface PathChipsProps {
	steps: string[];
	lookup: Map<string, InteractionInfo>;
	compact?: boolean;
}

const PathChips: FC<PathChipsProps> = ({ steps, lookup, compact = false }) => (
	<div className={styles.chips}>
		{steps.map((step, index) => {
			const info = resolveInfo(lookup, step);
			return (
				<span key={`${step}-${index}`} className={`${styles.chip} ${compact ? styles.chip_compact : ''}`}>
					<Dot color={info.color} size={5} />
					{info.label}
				</span>
			);
		})}
	</div>
);

export default PathChips;
